<template lang="pug">
div
  .fuli-container(v-if="isLogin" :class='{ mp: isMP }')
    .title
      .main(v-if='!isMP')
        img.return(
          @click='goBack',
          src='https://m.hellobike.com/resource/AppPlatformH5/fuli/te-QQ8uehL7W7_jNN9gmd.png'
        )
        span 福利中心
      .sub Hi，玩转福利中心出行更优惠
    .header(ref='header')
      .header-coupon(@click='goCoupon')
        template(v-if='preparing')
          .prepare-content - -
        template(v-else)
          img.icon.icon-coupon(
            src='https://m.hellobike.com/resource/helloyun/15979/-wl9GxaGWi.png'
          )
          .desc
            span 已获卡劵
            .amount &nbsp;{{ coupons }}&nbsp;
            .unit 张
          .common-arrow-right
      .header-bounty(@click='goBountyRecord')
        template(v-if='preparing')
          .prepare-content - -

        template(v-else)
          img.icon(
            src='https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png'
          )
          .desc
            span 奖励金
            .amount &nbsp;{{ points }}&nbsp;
            .unit 个
          .common-arrow-right
    NavBar(
      ref='nav',
      :navList='nav',
      :activeNav='activeNav',
      @changeNav='scrollToIndex'
    )
    NavBar.nav-fixed(
      ref='navFixed',
      :navList='nav',
      :type='2',
      :activeNav='activeNav',
      :showNav='showFixedNav',
      @changeNav='scrollToIndex'
    )
    .modules
      template(v-for='(m, index) in modules')
        component.fuli-module(
          :is='FULI_MODULE_COMPONENT_NEW[m]',
          :key='index',
          :points="points"
          :bounty='bounty',
          :class="[m, { 'exchange-style': m === 'welfare_bountyExchange' }]"
          :tab='param && param.to === m && typeof param.tab === "number" ? param.tab : null',
          :tabs='tabs',
          :new-module='true',
          bannerById='4ffa9b625b9c40ffa2eaf127e607a58e',
          @bounty='refreshBounty',
          @coupon='refreshCoupon',
          ref='module',
          @hideTab='hideTabs'
        )
    .rule.flex-mid(@click='goRule')
      span 福利中心规则
      .common-arrow-right
    check-in-new(
      :points="points"
      :bounty='bounty'
      @bounty='refreshBounty'
    )
  .fail-block(v-else)
    .fail-block-img
      img(src="https://m.hellobike.com/resource/helloyun/08345/UtlXJiq5RV.png?x-oss-process=image/quality,q_80")
    .fail-big-word 您还没有登录
    .fail-samll-word 请登录后查看福利信息
    .fail-btn(@click="goLogin") 登录

</template>

<script>
/* eslint-disable no-undef */
import { Native, env } from '@hb/NBridge/lib/h5';
import { getPageModule } from '@/api/common';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import config from '@/const/config';
import { getBountyBasicInfo, bountyExchangeTab } from '@/api/bounty';
import { getUserCoupons } from '@/api/fuli';
import { uploadEvent } from './common/helper';
import BountyTask from './components/bounty-alipay';
import CheckIn from './components/checkin';
import CardCoupons from './components/card-coupons';
import Exchange from './components/exchange';
import CardExclusive from './components/card-exclusive';
import CardCouponsNew from './components/card-coupons-new';
import NavBar from './components/nav-bar.vue';
import CheckInNew from './components/checkin-new';
import AdvMaster from './components/adv-master';
import ExternalEquity from './components/external-equity.vue';
import { ParamsUtil } from '../../utils/params';

import {
  debounce,
  getTokenAndLocation,
  isPreRender,
  tryCatch,
  smoothScroll,
} from '../../utils';
import {
  FULI_MODULE_NEW,
  FULI_MODULE_COMPONENT_NEW,
  FULI_MODULE_NAV,
  TABS,
  WELFARE_MY_CHANNEL,
  WELFARE_MY_CHANNEL_COMPLETE,
  WELFARE_REFRESH_DATA,
  FULI_MODULE_OLD_TO_NEW,
} from './consts';
import { welfareGo, welfareGoCoupon } from './utils';

const LOCAL_MODULES = [
  FULI_MODULE_NEW.welfare_attendance_new,
  FULI_MODULE_NEW.welfare_task_new,
  FULI_MODULE_NEW.welfare_exclusive_new,
  FULI_MODULE_NEW.welfare_card_new,
  FULI_MODULE_NAV.alipay_welfare_banner,
];

const LOCAL_NAV = [
  FULI_MODULE_NAV.welfare_task_new,
  FULI_MODULE_NAV.welfare_exclusive_new,
  FULI_MODULE_NAV.welfare_card_new,
  FULI_MODULE_NAV.welfare_bountyExchange,
  // FULI_MODULE_NAV.alipay_welfare_banner,
];

export default {
  components: {
    BountyTask,
    CheckIn,
    CardCoupons,
    Exchange,
    CardExclusive,
    CardCouponsNew,
    NavBar,
    CheckInNew,
    AdvMaster,
    ExternalEquity,
  },
  provide() {
    return {
      newTaskScene: () => this.newTaskScene,
      taskScene: () => '',
      isWelfareApp: false,
    };
  },
  data() {
    return {
      FULI_MODULE_NEW,
      FULI_MODULE_COMPONENT_NEW,
      modules: [...LOCAL_MODULES],
      nav: [...LOCAL_NAV],
      preparing: true,
      coupons: 0,
      points: 0,
      bounty: 0,
      isMP: false,
      param: null,
      lock: false,
      tabs: TABS,
      activeNav: 0,
      showFixedNav: false,
      navHeight: 0,
      clickTab: false,
      scrollTimer: null,
      isLogin: true,
      newTaskScene: false,
    };
  },
  async created() {
    document.title = '福利中心';
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    if (env.isEasyBikeApp) {
      this.hideNav();
    }
    const { token } = await getTokenAndLocation();
    if (token) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    this.getTabs();
    // 页面事件上传
    uploadEvent();
  },
  async mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    if (env.isEasyBikeApp) {
      this.hideNav();
      setTimeout(() => {
        window.addEventListener('pageshow', () => {
          this.hideNav();
        });
      });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.hideNav();
        }
      });
    }
    if (env.isAliMP || env.isAliMPMonitor) {
      UBT.pageView({
        pageId: 'Welfare',
        categoryId: 'platform',
        businessInfo: {
          port: '1',
          adsource: ParamsUtil.getParam('adsource'),
        },
      });
      this.isMP = true;
      this.hookMy();
      // 支付宝切换tab时重新监测登录状态，加载数据
      document.addEventListener('visibilitychange', async () => {
        if (document.visibilityState === 'visible') {
          const { token } = await getTokenAndLocation();
          if (token) {
            if (!this.isLogin) {
              this.isLogin = true;
              this.getBasic();
            }
          } else {
            this.isLogin = false;
          }
        }
      });
    }
    if (env.isEasyBikeApp) {
      UBT.pageView({
        pageId: 'Welfare',
        categoryId: 'platform',
        businessInfo: {
          port: '0',
          adsource: ParamsUtil.getParam('adsource'),
        },
      });
    }
    if (await Native.isLogin()) {
      this.getBasic();
    }

    window.addEventListener('scroll', this.scrollHandler);
  },
  destroyed() {
    if (env.isAliMP || env.isAliMPMonitor) {
      UBT.pageViewOut({
        pageId: 'welfare_new',
        categoryId: 'platform',
        businessInfo: {},
      });
    }
    window.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    async getTabs() {
      const { token } = await getTokenAndLocation();
      try {
        const res = await bountyExchangeTab({
          token,
        });
        if (res.data) {
          this.tabs = res.data;
        }
      // eslint-disable-next-line no-empty
      } catch {

      }
    },
    // 跟小程序通信
    hookMy() {
      const handler = setInterval(() => {
        if (window.my) {
          clearInterval(handler);
          window.my.postMessage({ event_action: WELFARE_MY_CHANNEL_COMPLETE });
          let old = () => {};
          if (typeof window.my.onMessage === 'function') {
            old = window.my.onMessage;
          }
          window.my.onMessage = (...params) => {
            // eslint-disable-next-line no-empty
            try {
              old(...params);
            } catch (e) {
              //
            }
            if (!this.lock && params && params[0]) {
              if (params[0].action === WELFARE_MY_CHANNEL) {
                if (params[0].payload && params[0].payload.param) {
                  const param = this.getParam(params[0].payload.param);
                  this.param = param;
                  this.scroll();
                }
                return;
              }
              if (params[0].action === WELFARE_REFRESH_DATA) {
                this.getBasic();
              }
            }
          };
        }
      }, 100);
      setTimeout(() => clearInterval(handler), 400);
    },
    done() {
      return Promise.all([
        (this.$refs.module || []).reduce((res, m) => {
          if (m && typeof m.start === 'function') {
            res.push(m.start());
          }
          return res;
        }, []),
      ]).catch(() => {});
    },
    goBack() {
      if (env.isEasyBikeApp) {
        Native.goBack();
      }
    },
    goLogin() {
      if (window.my) {
        // window.my.postMessage({
        //   command: 'goLoginPage',
        //   data: {
        //     returnPath:
        // `/pages/activity/web-view/web-view?url=${encodeURIComponent(window.location.href)}`,
        //     returnMethod: 'reLaunch',
        //   },
        // });
        window.my.postMessage({
          command: 'goLoginPage',
          data: {
            returnPath: 'pages/welfare/index',
            returnMethod: 'reLaunch',
          },
        });
      } else {
        Native.closeWebView();
      }
    },
    hideNav: debounce(() => {
      Native.toggleNavBar({ isShow: false }).catch(() => {});
    }),
    goBountyRecord() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'welfare_Bonus',
        categoryId: 'platform',
        businessInfo: {},
      });
      welfareGo(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/bounty/exchange?adsource=1&isHideBonus=true`,
      );
    },
    getParam(param) {
      if (param) {
        return param.split('&').reduce((res, cur) => {
          if (cur) {
            if (cur.indexOf('=') !== -1) {
              const [key, value] = cur.split('=');
              if (key === 'tab') {
                res[key] = Number(value);
              } else if (key === 'to') {
                res[key] = FULI_MODULE_OLD_TO_NEW[value] || value;
              } else {
                res[key] = value;
              }
            } else {
              res[cur] = true;
            }
          }
          return res;
        }, {});
      }
      const { tab, to } = this.$route.query;
      const realTab = FULI_MODULE_OLD_TO_NEW[tab];
      if (realTab !== undefined || to !== undefined) {
        return { tab: realTab, to };
      }
      return this.param || {};
    },
    scroll() {
      const param = this.getParam();
      const { to } = param;
      if (to) {
        const ele = document.querySelector(`.${to}`);
        if (ele) {
          setTimeout(() => {
            const { offsetTop: top } = ele;
            try {
              window.scrollTo({
                top: top - this.getNavHeight() + 12,
                behavior: 'smooth',
              });
            } catch (error) {
              window.scrollTo(0, top);
            }
          }, 500);
        } else {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      }
    },
    goCoupon() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'welfare_morecoupon',
        categoryId: 'platform',
        businessInfo: {},
      });
      welfareGoCoupon();
    },
    goRule() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'welfare_rule',
        categoryId: 'platform',
        businessInfo: {},
      });
      welfareGo(
        'https://m.hellobike.com/mf/spa/u_yzmpzd/latest/MA2206293249099363266854912.html?activityCode=MA2206293249099363266854912',
      );
    },
    async refreshBounty() {
      const { token } = await getTokenAndLocation();
      const basic = await getBountyBasicInfo({ token, pointType: 1 })
        .then((v) => v.data || {})
        .catch(() => ({}));

      this.bounty = basic.amount || 0;
      this.points = basic.points || 0;
    },
    async refreshCoupon() {
      const { token } = await getTokenAndLocation();
      return getUserCoupons({ token })
        .then((v) => v.data || {})
        .catch(() => ({}))
        .then((coupons) => {
          this.coupons = coupons.couponCount || 0;
        });
    },
    async getBasic() {
      const { token } = await getTokenAndLocation();
      if (!token && !(await Native.isLogin())) {
        return;
      }
      await this.refreshCoupon();
      this.preparing = false;

      getPageModule({
        token,
        pageType: 20,
        from: 'MP',
        systemCode: 65,
      })
        .then((v) => {
          if (v && v.data && v.data.moduleList) {
            this.modules = v.data.moduleList.map((m) => {
              if (
                m.moduleKey === FULI_MODULE_NEW.welfare_bountyExchange
                && m.moduleData
              ) {
                this.tabs = tryCatch(() => m.moduleData[0].data, []);
              }
              return m.moduleKey;
            });
            this.nav = v.data.moduleList
              .map((m) => {
                if (m.moduleKey === FULI_MODULE_NEW.alipay_welfare_banner) {
                  return false;
                }
                if (m.moduleKey === FULI_MODULE_NEW.welfare_exclusive_new) {
                  UBT.moduleExpose({
                    pageId: 'welfare_new',
                    categoryId: 'platform',
                    moduleId: 'APPcc_tab',
                    contentId: 'APPcc_tab',
                    exposureTimes: 1,
                    businessInfo: {},
                  });
                } else if (m.moduleKey === FULI_MODULE_NEW.welfare_card_new) {
                  UBT.moduleExpose({
                    pageId: 'welfare_new',
                    categoryId: 'platform',
                    moduleId: 'coupon_tab',
                    contentId: 'coupon_tab',
                    exposureTimes: 1,
                    businessInfo: {},
                  });
                } else if (m.moduleKey === FULI_MODULE_NEW.welfare_task_new) {
                  UBT.moduleExpose({
                    pageId: 'welfare_new',
                    categoryId: 'platform',
                    moduleId: 'getbouns_tab',
                    contentId: 'getbouns_tab',
                    exposureTimes: 1,
                    businessInfo: {},
                  });
                } else if (
                  m.moduleKey === FULI_MODULE_NEW.welfare_bountyExchange
                ) {
                  UBT.moduleExpose({
                    pageId: 'welfare_new',
                    categoryId: 'platform',
                    moduleId: 'use_bonustab',
                    contentId: 'use_bonustab',
                    exposureTimes: 1,
                    businessInfo: {},
                  });
                }

                return FULI_MODULE_NAV[m.moduleKey];
              })
              .filter((key) => key);
          }
          this.$nextTick(() => {
            this.done().then(() => {
              this.scroll();
            });
          });
        })
        .catch(() => {});
    },
    getNavHeight() {
      if (!this.navHeight) {
        this.navHeight = this.$refs.navFixed.$el.getBoundingClientRect().height;
      }
      return this.navHeight;
    },
    scrollHandler() {
      if (this.$refs.nav && this.$refs.header) {
        const { top, height } = this.$refs.nav.$el.getBoundingClientRect();
        this.showFixedNav = top + height < height * 1.4;

        // 监听滚动结束
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.clickTab = false;
        }, 100);

        if (this.clickTab) {
          return;
        }
        this.scrollTab(height);
      }
    },
    scrollToIndex(index) {
      if (index === undefined) {
        return;
      }

      this.activeNav = index;
      this.clickTab = true;
      const el = tryCatch(
        () => this.$refs.module.filter(
          (v) => v.$children.length && v.$el && v.$el.nodeType !== 8,
        )[index],
        null,
      );
      if (!el || !el.$el) {
        return;
      }

      smoothScroll(
        el.$el.getBoundingClientRect().top
          + window.scrollY
          - this.getNavHeight(),
      );
    },
    hideTabs(key) {
      this.nav = (this.nav || []).filter((v) => !(v === key));
    },
    scrollTab(height) {
      const { pageYOffset: baseTop } = window;
      const body = document.querySelector('body');
      // 滚到底部，选中最后一个导航
      if (baseTop + body.clientHeight >= body.scrollHeight) {
        this.activeNav = this.nav.length - 1;
        return;
      }
      (this.$refs.module || [])
        .map((v) => v.$el.offsetTop)
        // .sort((a, b) => a - b)
        .filter((v) => v)
        .forEach((v, index, array) => {
          if (
            baseTop + height * 1.4 >= v
            && baseTop + height * 1.4 <= array[index + 1]
            && index !== this.activeNav
          ) {
            this.activeNav = index;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.fuli-container {
  min-height: 100%;
  width: 100%;
  overflow-x: hidden;
  font-size: 20px;
  padding-top: 0.44rem;
  background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/0astHTfCFAG2jzXj-2UrL.png);
  background-repeat: no-repeat;
  background-position-y: 0;
  background-size: 100%;
  background-color: #f0f3f5;

  &.mp {
    padding-top: 0;
    background-image: url(https://m.hellobike.com/resource/helloyun/15979/nypp6XSB9C.svg);
  }

  .rule {
    font-size: 0.12rem;
    color: #879099;
    margin-top: 0.18rem;
    margin-bottom: 0.27rem;

    .common-arrow-right {
      border-color: #879099;
    }
  }

  .title {
    padding: 0.1rem 0.18rem 0;

    .main {
      height: 0.44rem;
      display: flex;
      align-items: center;
      font-size: 0.18rem;
      font-weight: 600;
      color: #fff;
      line-height: 0.18rem;
      margin-bottom: -0.07rem;

      .return {
        height: 0.16rem;
        margin-right: 0.06rem;
      }
    }

    .sub {
      // margin-top: 0.1rem;
      font-size: 0.12rem;
      color: #fff;
    }
  }

  .header {
    display: flex;
    margin: 0.09rem 0.16rem 0.26rem;

    .header-coupon,
    .header-bounty {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;

      .icon {
        width: 0.14rem;
        height: 0.14rem;
        margin-right: 0.05rem;
      }

      .icon-coupon {
        height: 0.12rem;
      }

      .desc {
        display: flex;
        align-items: center;
        font-size: 0.12rem;
        color: #fff;

        :first-of-type,
        .unit {
          opacity: 0.8;
        }

        .amount {
          font-weight: 500;
          opacity: 1;
        }
      }
    }

    .header-bounty {
      margin-left: 0.23rem;
    }
  }

  .nav {
    display: flex;
    justify-content: space-between;
    padding: 0 0.16rem 0.1rem;

    .nav-item {
      flex-direction: column;
      flex: 1;

      .nav-name {
        font-size: 0.16rem;
        line-height: 0.22rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 0.06rem;
      }

      .line {
        width: 0.26rem;
        height: 0.04rem;
        background: #fff7f5;
        border-radius: 0.02rem;
        opacity: 0;
        transition: all 0.2s ease;
      }

      &.active {
        .nav-name {
          font-size: 0.16rem;
          font-weight: 500;
          color: #fff;
        }

        .line {
          opacity: 1;
        }
      }
    }

    &.nav-fixed {
      position: fixed;
      width: 100%;
      left: 0;
      right: 0;
      top: 0;
      background: #f94816;
      opacity: 1;
      pointer-events: none;
      transition: opacity 0.2s ease;
      box-shadow: 0 0.01rem 0.06rem 0 rgba(0, 0, 0, 0.06);
      z-index: 100;
      padding: 0.11rem 0.16rem 0.11rem;
      white-space: nowrap;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }
    }
  }

  .fuli-module {
    width: 3.51rem;
    background: #fff;
    border-radius: 0.12rem;
    margin: 0 auto;
    margin-bottom: 0.16rem;
  }

  .exchange-style {
    width: 100%;
    background: #f0f3f5; // 确保背景颜色正确
    margin: 0 auto;
    border-radius: 0;
  }
}

.fail-block {
  // margin-top: 0.57rem;
  background: #fff;

  .fail-block-img {
    padding-top: 1.21rem;
    display: flex;
    justify-content: center;

    img {
      width: 1.6rem;
      height: 1.5rem;
    }
  }

  .fail-big-word {
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.16rem;
    font-weight: 400;
    line-height: 0.22rem;
    text-align: center;
    color: #242729;
  }

  .fail-samll-word {
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.14rem;
    font-weight: 400;
    line-height: 0.2rem;
    text-align: center;
    color: #879099;
    margin-top: 0.04rem;
  }

  .fail-btn {
    text-align: center;
    width: 1rem;
    height: 0.4rem;
    background: #08f;
    color: #fff;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.16rem;
    font-weight: 500;
    border-radius: 0.04rem;
    line-height: 0.4rem;
    margin: 0.2rem auto;
  }
}
</style>
